"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberInformation = exports.createAttributesFromCustomer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const call_detail_key_value_tile_1 = require("./call_detail_key_value_tile");
const createAttributesFromCustomer = (customer) => {
    const attributes = [];
    if (customer.planType) {
        attributes.push({ key: 'Plan Type', value: customer.planType, widthPercentage: 30 });
    }
    if (customer.contractNumber) {
        attributes.push({
            key: 'Plan Number',
            value: customer.contractNumber,
            widthPercentage: 30,
            isCopyableYn: true,
        });
    }
    if (typeof customer.callsAvailable === 'number') {
        attributes.push({
            key: 'Calls Available',
            value: customer.callsAvailable.toString(),
            widthPercentage: 30,
        });
    }
    if (customer.address) {
        // address should be wider than the other columns
        attributes.push({
            key: 'Covered Property Address',
            value: customer.address,
            widthPercentage: 30,
        });
    }
    return attributes;
};
exports.createAttributesFromCustomer = createAttributesFromCustomer;
const MemberInformation = ({ customer, widthPercentage = 100, columnsPerRow, style, dataIdPrefix, keyValueStyles, keyValueTileStyles, memberInformationStyles = {}, isTrayOpen, }) => {
    var _a;
    const theme = (0, ui_react_1.useTheme)();
    const effectiveTitleFontSize = (memberInformationStyles.titleFontSize ||
        theme.text.size.mediumLarge);
    const effectiveItemFontSize = ((keyValueStyles === null || keyValueStyles === void 0 ? void 0 : keyValueStyles.fontSize) || theme.text.size.medium);
    const customerAttributes = (0, exports.createAttributesFromCustomer)(customer);
    const attributesSection = customerAttributes.length > 0 ? ((0, jsx_runtime_1.jsx)(call_detail_key_value_tile_1.CallDetailKeyValueTile, { keyValuePairs: customerAttributes, columnsPerRow: columnsPerRow, dataIdPrefix: dataIdPrefix, keyValueStyles: { fontSize: effectiveItemFontSize }, keyValueTileStyles: keyValueTileStyles, isTrayOpen: isTrayOpen })) : ((0, jsx_runtime_1.jsx)(NoAttributesSection, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ size: "notQuiteAllTheWayMediumLarge", headingFontFamily: true, "data-testid": `${dataIdPrefix}-no-member-information-available` }, { children: "No Member Information Available" })) }));
    return ((0, jsx_runtime_1.jsxs)(MemberInformationWrapper, Object.assign({ widthPercentage: widthPercentage, style: style }, { children: [(0, jsx_runtime_1.jsx)(HeaderWrapper, Object.assign({ titleFontSize: effectiveTitleFontSize, "data-testid": `${dataIdPrefix}-member-information-header`, headerBottomMargin: (_a = memberInformationStyles.headerBottomMargin) !== null && _a !== void 0 ? _a : '0.5rem' }, { children: "Member Information" })), attributesSection] })));
};
exports.MemberInformation = MemberInformation;
const MemberInformationWrapper = ui_react_1.styled.section(props => (Object.assign({ display: 'inline-flex', flexDirection: 'column', width: props.widthPercentage ? `${props.widthPercentage}%` : undefined }, props.style)));
const HeaderWrapper = ui_react_1.styled.div(props => ({
    marginBottom: props.headerBottomMargin,
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
    lineHeight: props.theme.text.lineHeight.medium,
    fontSize: props.titleFontSize,
}));
const NoAttributesSection = (0, ui_react_1.styled)(ui_react_1.Row)(({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: theme.colors.grey01A50,
    padding: '2rem 0',
}));
//# sourceMappingURL=member_information.js.map